import { render } from "./PreschoolScoreReport.vue?vue&type=template&id=520de0be&ts=true"
import script from "./PreschoolScoreReport.vue?vue&type=script&lang=ts"
export * from "./PreschoolScoreReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__